(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-choice-button/assets/javascripts/clear-button.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-choice-button/assets/javascripts/clear-button.js');
"use strict";

const CouponChoiceButton = svs.components.tipsen.couponChoiceButton.CouponChoiceButton;
const ClearButton = _ref => {
  let isCouponEmpty = _ref.isCouponEmpty,
    onClearCoupon = _ref.onClearCoupon;
  return React.createElement(CouponChoiceButton, {
    ariaLabel: "Rensa tecken i kupong",
    className: "coupon-toolbox-clear-button",
    "data-testid": "clear-button",
    icon: "dustbin",
    isDisabled: isCouponEmpty,
    onClick: onClearCoupon
  }, "Rensa");
};
setGlobal('svs.components.tipsen.couponChoiceButton.ClearButton', ClearButton);

 })(window);